var symphony = symphony || {};

;(function() {

  symphony.sharePopup = function(network, el) {

			var winTop = (screen.height / 2) - (350 / 2);
			var winLeft = (screen.width / 2) - (520 / 2);
			var shareUrl;
			var url = encodeURIComponent(window.location.href);
			var headline = encodeURIComponent($.trim($(el).parent().parent().find('p:first-of-type').text()));
			var title = encodeURIComponent($.trim($(el).parent().parent().find('.shareCard-stat').text()));
			var descr = encodeURIComponent($.trim($(el).parent().parent().find('.shareCard-cta').text()));
			var image = $('.rowStory-photo img').attr('src') || $('.rowStory-photo img').data('src');

			if(headline === "") {
				headline = document.title;
			}

			console.log(headline);
			console.log(url);

			if (network != "AddThis" && typeof utag != 'undefined') {
				utag.link({
					'event_name' : 'Social Aware', //Event Name
					'link_text' : 'Submit', //Link Text
					'page_name' : utag_data.page_name,//Page Name
					'site_section' : utag_data.site_section, //Site Section
					'site_type' : 'SAL:' + utagSite, //Site Type
					'login_status' : 'Not Logged In', //Login Status
					'event_type' : 'social_share', //Event Type
					'article_title' : typeof utag_data.article_title != 'undefined' ? utag_data.article_title : '',//Newsroom Article title
					'article_author' : typeof utag_data.article_author != 'undefined' ? utag_data.article_author : '', //Newsroom Article Author
					'share_type' : network, //Social Share button which is beingclicked
					'button_location' : $(el).data('btnlocation') //Location or section of the SocialShare buttons on the page
				});
			}


			switch (network) {
				case "Facebook":
					FB.ui({
					  method: 'share',
					  mobile_iframe: false,
					  href: window.location.href,
					}, function(response){});
					return;
				case "Pinterest":
					shareUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&media=' + image + '&description=' + descr;
					break;
				case "Twitter":
					shareUrl = 'https://twitter.com/home/?status=' + headline + ' ' + url + ' @salvationarmyusa'
					break;
				case "AddThis":
					var clickedIcon = el;
					$(clickedIcon).parent('li').toggleClass('isClicked');
					$(clickedIcon).next('.addthis_sharing_toolbox').toggleClass('isVisible');
					
					return;
			}
			//console.log(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
			window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');

  };

})();
